namespace TabAurous.Production {
    export namespace TreeMakingforJWService {
        export const baseUrl = 'Production/TreeMakingforJW';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<TreeMakingItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Production/TreeMakingforJW/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>TreeMakingforJWService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
